export default "__VITE_ASSET__D_nDEyt5__"